<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style>
/* 重置默认样式 */
body {
  margin: 0;
  padding: 0;
  overflow: hidden; /* 隐藏body的滚动条 */
  font-family: "Microsoft YaHei", "微软雅黑", sans-serif; /* 添加微软雅黑字体 */
}

#app {
  font-family: "Microsoft YaHei", "微软雅黑", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh; /* 设置app高度为视口高度 */
  overflow-y: auto; /* 允许app内部滚动 */
}

/* 隐藏滚动条但保留滚动功能 */
#app::-webkit-scrollbar {
  display: none; /* 对于 Chrome, Safari 和 Opera */
}

#app {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

/* 移除全局的 nav padding */
/* nav {
  padding: 30px;
} */

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
